import React from 'react';
import ReactTooltip from 'react-tooltip';
import classNames from 'classnames/bind';
import styles from './FormInput.module.scss';

export type InputType =
  | 'text'
  | 'number'
  | 'email'
  | 'password'
  | 'checkbox'
  | 'date';

type Props = {
  value: any;
  id?: string;
  type?: InputType;
  name: string;
  label?: string;
  placeholder?: string;
  explicationMessage?: string;
  tooltipMessage?: string;
  className?: string;
  onChange: (newValue: any) => void;
  onBlur?: (e:any) => void;
  pattern?: string;
  max?: string;
};

const FormInput = ({
  value = '',
  id,
  name,
  type = 'text',
  label,
  placeholder,
  explicationMessage,
  tooltipMessage,
  className,
  onChange,
  onBlur,
  pattern,
  max,
}: Props) => {
  console.log('className', className);
  return (
    <label className={classNames(styles.wrapper, className)}>
      {label && <span className={styles.label}>{label}</span>}
      <input
        id={id}
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        className={styles.input}
        pattern={pattern}
        max={max}
      />
      {tooltipMessage && explicationMessage && (
        <>
          <div
            className={styles.explication}
            data-tip
            data-for="explicationTooltip"
          >
            {explicationMessage}
          </div>
          <ReactTooltip
            id="explicationTooltip"
            place="bottom"
            effect="solid"
            multiline={true}
            className={styles.tooltip}
          >
            {tooltipMessage}
          </ReactTooltip>
        </>
      )}
    </label>
  );
};

export default FormInput;
